/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { RootState } from '@ink-ai/portal/reducers';
import { Card, CircularProgress, Modal, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

export const SocketLoading = () => {
  const webSocketState = useSelector((state: RootState) => state.webSocket);
  return (
    <Modal open={!webSocketState.connected}>
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 200,
          bgcolor: 'background.paper',
          p: 4,
        }}
      >
        <div className="flex flex-col items-center">
          <CircularProgress size={80} />
          <Typography
            variant="overline"
            sx={{
              mt: 2,
            }}
          >
            Connecting...
          </Typography>
        </div>
      </Card>
    </Modal>
  );
};
